export default () => ({
  MuiCssBaseline: {
    '@global': {
      body: {
        backgroundColor: '#f2f2f2'
      }
    }
  }
});
